<div class="master-login-container">
    <app-only-table-generator
        [apiInfo]="null"
        [tableData]="modalInputData.data.users"
        [tableInput]="tableGenInput"
        (gridRef)="agGrid = $event"
        (scroll)="agGridBodyScroll($event)"
    ></app-only-table-generator>
</div>
